const e = 864e13;
export {
  e as MAX_DATE
};
